<app-spinner-service></app-spinner-service>

<form [formGroup]="form" class="form-grid">
  <fieldset class="form-fieldset">
    <legend class="form-block-legend">
      <i class="pi pi-user"></i>
      Prestador de Serviços
    </legend>
    
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label for="prestadorServico">
          Prestador de Serviços <span class="required">*</span>
        </label>
        <input 
          pInputText 
          formControlName="prestadorServico" 
          id="prestadorServico"
          [ngClass]="{'invalid-field': form.get('prestadorServico')?.invalid && form.get('prestadorServico')?.touched}"
          placeholder="Informe o prestador de serviços" />
        <small *ngIf="form.get('prestadorServico')?.invalid && form.get('prestadorServico')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Prestador de serviços é obrigatório.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Nome ou razão social do prestador
        </small>
      </div>

      <div class="p-field p-col-12">
        <label for="simplesNacional">Opção Pelo Simples Nacional</label>
        <input 
          pInputText 
          [value]="'Optante do Simples Nacional'" 
          id="simplesNacional" 
          disabled 
          class="disabled-field" />
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Status do Simples Nacional
        </small>
      </div>

      <div class="p-field p-col-12 p-md-4">
        <label for="ufId">
          Estado <span class="required">*</span>
        </label>
        <p-dropdown 
          [options]="ufOptions" 
          optionLabel="nome" 
          optionValue="id" 
          formControlName="ufId"
          [ngClass]="{'invalid-field': form.get('ufId')?.invalid && form.get('ufId')?.touched}"
          placeholder="Selecione o estado">
        </p-dropdown>
        <small *ngIf="form.get('ufId')?.invalid && form.get('ufId')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Estado é obrigatório.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Estado da prestação de serviços
        </small>
      </div>

      <div class="p-field p-col-12 p-md-8">
        <label for="municipioId">
          Município <span class="required">*</span>
        </label>
        <p-dropdown 
          [options]="municipioOptions" 
          optionLabel="nome" 
          optionValue="id" 
          formControlName="municipioId"
          [ngClass]="{'invalid-field': form.get('municipioId')?.invalid && form.get('municipioId')?.touched}"
          placeholder="Selecione o município">
        </p-dropdown>
        <small *ngIf="form.get('municipioId')?.invalid && form.get('municipioId')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Município é obrigatório.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Município da prestação de serviços
        </small>
      </div>
    </div>
  </fieldset>

  <fieldset class="form-fieldset">
    <legend class="form-block-legend">
      <i class="pi pi-users"></i>
      Tomador de Serviços
    </legend>
    
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label for="clienteId">
          Tomador de Serviços <span class="required">*</span>
        </label>
        <p-dropdown 
          [options]="clienteOptions" 
          (onChange)="onTomadorChange($event)" 
          formControlName="clienteId"
          [ngClass]="{'invalid-field': form.get('clienteId')?.invalid  && form.get('clienteId')?.touched}"
          placeholder="Selecione o tomador">
        </p-dropdown>
        <small *ngIf="form.get('clienteId')?.invalid && form.get('clienteId')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Tomador é obrigatório.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Selecione o cliente tomador do serviço
        </small>
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="indicadorDestinatario">
          Indicador do destinatário <span class="required">*</span>
        </label>
        <p-dropdown
          inputId="indicadorDestinatario"
          [options]="indicadorDestinatarioOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="indicadorDestinatario"
          [disabled]="true"
          placeholder="Selecione o indicador do destinatário"
          [ngClass]="{'invalid-field': form.get('indicadorDestinatario')?.invalid && form.get('indicadorDestinatario')?.touched}">
        </p-dropdown>
        <small *ngIf="form.get('indicadorDestinatario')?.invalid && form.get('indicadorDestinatario')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Indicador do destinatário é obrigatório.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Identifica o destinatário da operação na DPS nacional.
        </small>
      </div>

      <div class="p-field p-col-12">
        <div class="info-box">
          <p class="info-text">
            <i class="pi pi-exclamation-triangle" style="color: #e53935;"></i>
            <strong>Caso não possua um tomador cadastrado anteriormente, clique
              <a (click)="redirecionaParaCadastro()" class="link-cadastro">aqui</a>
              para efetuar o cadastro</strong>
          </p>
        </div>
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="cpfCnpj">CNPJ/CPF</label>
        <input 
          pInputText 
          formControlName="cpfCnpj" 
          [attr.disabled]="true" 
          class="disabled-field" />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="razaoSocial">Razão Social</label>
        <input 
          pInputText 
          formControlName="razaoSocial" 
          [attr.disabled]="true" 
          class="disabled-field" />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="apelido">Apelido</label>
        <input 
          pInputText 
          formControlName="apelido" 
          [attr.disabled]="true" 
          class="disabled-field" />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="email">Email</label>
        <input 
          pInputText 
          formControlName="email" 
          [attr.disabled]="true" 
          class="disabled-field" />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="telefone">Telefone de Contato</label>
        <input 
          pInputText 
          formControlName="telefone" 
          [attr.disabled]="true" 
          class="disabled-field" />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="inscricaoMunicipal">Inscrição Municipal</label>
        <input 
          pInputText 
          formControlName="inscricaoMunicipal" 
          [attr.disabled]="true" 
          class="disabled-field" />
      </div>

      <div class="p-field p-col-12 p-md-4">
        <label for="cep">CEP</label>
        <input 
          pInputText 
          formControlName="cep" 
          [attr.disabled]="true" 
          class="disabled-field" />
      </div>

      <div class="p-field p-col-12 p-md-4">
        <label for="estado">Estado</label>
        <input 
          pInputText 
          formControlName="estado" 
          [attr.disabled]="true" 
          class="disabled-field" />
      </div>

      <div class="p-field p-col-12 p-md-4">
        <label for="bairro">Bairro</label>
        <input 
          pInputText 
          formControlName="bairro" 
          [attr.disabled]="true" 
          class="disabled-field" />
      </div>

      <div class="p-field p-col-12 p-md-3">
        <label for="tipoLogradouro">Tipo Logradouro</label>
        <input 
          pInputText 
          formControlName="tipoLogradouro" 
          [attr.disabled]="true" 
          class="disabled-field" />
      </div>

      <div class="p-field p-col-12 p-md-6">
        <label for="logradouro">Logradouro</label>
        <input 
          pInputText 
          formControlName="logradouro" 
          [attr.disabled]="true" 
          class="disabled-field" />
      </div>

      <div class="p-field p-col-12 p-md-3">
        <label for="numero">Número</label>
        <input 
          pInputText 
          formControlName="numero" 
          [attr.disabled]="true" 
          class="disabled-field" />
      </div>

      <div class="p-field p-col-12">
        <label for="complemento">Complemento</label>
        <input 
          pInputText 
          formControlName="complemento" 
          [attr.disabled]="true" 
          class="disabled-field" />
      </div>
    </div>
  </fieldset>

  <fieldset class="form-fieldset">
    <legend class="form-block-legend">
      <i class="pi pi-briefcase"></i>
      Serviço
    </legend>
    
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label for="itemListaServico">
          Código de Serviço <span class="required">*</span>
        </label>
        <input 
          pInputText 
          formControlName="itemListaServico"
          [ngClass]="{'invalid-field': form.get('itemListaServico')?.invalid && form.get('itemListaServico')?.touched}"
          placeholder="Informe o código do serviço" />
        <small *ngIf="form.get('itemListaServico')?.invalid && form.get('itemListaServico')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Código de serviço é obrigatório.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Código da lista de serviços
        </small>
      </div>

      <div class="p-field p-col-12" *ngIf="isEmitenteSaoGoncaloRj()">
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Prestador em São Gonçalo/RJ (padrão nacional): o NBS é enviado automaticamente na DPS (padrão advocacia: 1.1301.20.00). O código tributário municipal não é utilizado; o código tributário nacional é derivado do item da LC 116.
        </small>
      </div>

      <div class="p-field p-col-12" *ngIf="isEmitenteTeresinaPi()">
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Prestador em Teresina/PI (ABRASF/DSF): utilize o item da LC 116 com ponto (ex.: 17.14). O código NBS e o código tributário municipal não são utilizados. O CNAE municipal de 9 dígitos é obtido do cadastro do escritório.
        </small>
      </div>

      <div class="p-field p-col-12" *ngIf="!municipioNaoExigeCodigoNbs()">
        <label for="codigoNbs">
          Código NBS <span class="required">*</span>
        </label>
        <p-dropdown
          inputId="codigoNbs"
          [options]="codigoNbsOptions"
          optionLabel="label"
          optionValue="value"
          formControlName="codigoNbs"
          [filter]="true"
          filterBy="label"
          placeholder="Selecione o código NBS do serviço"
          [ngClass]="{'invalid-field': form.get('codigoNbs')?.invalid && form.get('codigoNbs')?.touched}">
        </p-dropdown>
        <small *ngIf="form.get('codigoNbs')?.invalid && form.get('codigoNbs')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Código NBS é obrigatório.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Selecione o código NBS correspondente ao serviço prestado.
        </small>
      </div>

      <div class="p-field p-col-12">
        <label for="descricaoId">
          Discriminação de Serviços <span class="required">*</span>
        </label>
        <p-dropdown 
          [options]="descricaoPadraoOptions" 
          (onChange)="onDescricaoChange($event)"
          formControlName="descricaoId"
          [ngClass]="{'invalid-field': form.get('descricaoId')?.invalid && form.get('descricaoId')?.touched}"
          placeholder="Selecione a discriminação">
        </p-dropdown>
        <small *ngIf="form.get('descricaoId')?.invalid && form.get('descricaoId')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Discriminação é obrigatória.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Selecione a descrição padrão do serviço
        </small>
      </div>

      <div class="p-field p-col-12">
        <div class="info-box">
          <p class="info-text">
            <i class="pi pi-exclamation-triangle" style="color: #e53935;"></i>
            <strong>Caso não possua uma discriminação dos serviços cadastrada anteriormente, clique
              <a (click)="redirecionaParaDescricaoPadrao()" class="link-cadastro">aqui</a>
              para efetuar o cadastro e preencha abaixo com um texto personalizado que queira utilizar
              exclusivamente nesta emissão.</strong>
          </p>
        </div>
      </div>

      <div class="p-field p-col-12">
        <label for="discriminacao">
          Discriminação Personalizada
          <span class="required">*</span>
        </label>
        <textarea 
          pInputTextarea 
          formControlName="discriminacao"
          [ngClass]="{'invalid-field': form.get('discriminacao')?.invalid && form.get('discriminacao')?.touched}"
          placeholder="Descreva detalhadamente o serviço prestado"
          rows="10">
        </textarea>
        <small *ngIf="form.get('discriminacao')?.invalid && form.get('discriminacao')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Discriminação é obrigatória.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Descrição detalhada do serviço prestado
        </small>
      </div>

      <div class="p-field p-col-12 p-md-4">
        <label for="valorServicos">
          Valor do Serviço <span class="required">*</span>
        </label>
        <input 
          pInputText 
          formControlName="valorServicos" 
          mask="separator.2" 
          prefix="R$ "
          [ngClass]="{'invalid-field': form.get('valorServicos')?.invalid && form.get('valorServicos')?.touched}"
          placeholder="R$ 0,00" />
        <small *ngIf="form.get('valorServicos')?.invalid && form.get('valorServicos')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Valor do serviço é obrigatório.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Valor total do serviço prestado
        </small>
      </div>

      <div class="p-field p-col-12">
        <div class="p-checkbox-wrapper">
          <p-checkbox 
            formControlName="isRetroativa"
            inputId="isRetroativa"
            [binary]="true"
            (onChange)="onRetroativaChange($event)">
          </p-checkbox>
          <label for="isRetroativa" class="checkbox-label">
            Deseja emitir NFS-e retroativa?
          </label>
        </div>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Marque esta opção se precisar emitir uma nota fiscal com data de competência diferente da data atual
        </small>
      </div>

      <div class="p-field p-col-12 p-md-4" *ngIf="form.get('isRetroativa')?.value">
        <label for="dataCompetencia">
          Data de Competência <span class="required">*</span>
        </label>
        <p-calendar 
          formControlName="dataCompetencia"
          id="dataCompetencia"
          [showIcon]="true"
          dateFormat="dd/mm/yy"
          [showButtonBar]="true"
          [ngClass]="{'invalid-field': form.get('dataCompetencia')?.invalid && form.get('dataCompetencia')?.touched}"
          placeholder="Selecione a data de competência"
          [maxDate]="dataAtual"
          [readonlyInput]="false">
        </p-calendar>
        <small *ngIf="form.get('dataCompetencia')?.invalid && form.get('dataCompetencia')?.touched" class="error-message">
          <i class="pi pi-exclamation-triangle"></i>
          Data de competência é obrigatória.
        </small>
        <small class="field-hint">
          <i class="pi pi-info-circle"></i>
          Período de competência do serviço prestado (mês/ano de referência)
        </small>
      </div>
    </div>
  </fieldset>

  <div class="form-actions">
    <p-button 
      type="button" 
      label="Voltar" 
      icon="pi pi-arrow-left" 
      severity="secondary"
      (click)="voltar()">
    </p-button>
    <p-button 
      type="button" 
      label="Emitir Nota Fiscal" 
      icon="pi pi-check" 
      class="p-button-primary"
      [disabled]="form.invalid || (form.get('isRetroativa')?.value && !form.get('aceiteDeclaracao')?.value)"
      (click)="emitirNotaFiscal()">
    </p-button>
  </div>
</form>

<p-dialog 
  header="Pré-visualização NFS-e" 
  [modal]="true" 
  [(visible)]="mostrarNota" 
  [style]="{ width: '75rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" 
  [maximizable]="true"
  class="custom-dialog">
  
  <div class="dialog-content-wrapper" *ngIf="notaMaisRecente">
    <div class="detail-card">
      <div class="detail-header">
        <i class="pi pi-file-pdf" style="color: #1f2842; font-size: 2rem; margin-right: 1rem;"></i>
        <div>
          <h2 class="detail-title">NFS-e - {{notaMaisRecente?.dataEmissao ? formataData(notaMaisRecente.dataEmissao) : 'Nova'}}</h2>
          <p class="detail-subtitle">Nota Fiscal de Serviço Eletrônica</p>
        </div>
      </div>

      <div class="detail-grid">
        <div class="detail-item">
          <div class="detail-label">
            <i class="pi pi-calendar"></i>
            <span>Data de Emissão</span>
          </div>
          <div class="detail-value">{{notaMaisRecente?.dataEmissao ? formataData(notaMaisRecente.dataEmissao) : ''}}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label">
            <i class="pi pi-tag"></i>
            <span>Natureza Operação</span>
          </div>
          <div class="detail-value">{{notaMaisRecente?.naturezaOperacao || ''}}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label">
            <i class="pi pi-check-circle"></i>
            <span>Simples Nacional</span>
          </div>
          <div class="detail-value">{{notaMaisRecente?.optanteSimplesNacional || ''}}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label">
            <i class="pi pi-star"></i>
            <span>Incentivador Cultural</span>
          </div>
          <div class="detail-value">{{notaMaisRecente?.incentivadorCultural || ''}}</div>
        </div>
      </div>

      <div class="detail-section">
        <h3 class="section-title">
          <i class="pi pi-user"></i>
          Prestador
        </h3>
        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-label">CNPJ</div>
            <div class="detail-value">{{notaMaisRecente?.prestador.cnpj || ''}}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">Inscrição Municipal</div>
            <div class="detail-value">{{notaMaisRecente?.prestador.inscricao_municipal || ''}}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">Código Município</div>
            <div class="detail-value">{{notaMaisRecente?.prestador.codigo_municipio || ''}}</div>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <h3 class="section-title">
          <i class="pi pi-users"></i>
          Tomador
        </h3>
        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-label">CPF/CNPJ</div>
            <div class="detail-value">{{notaMaisRecente?.tomador.cpf || notaMaisRecente?.tomador.cnpj || ''}}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">Razão Social</div>
            <div class="detail-value">{{notaMaisRecente?.tomador.razao_social || ''}}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">Telefone</div>
            <div class="detail-value">{{notaMaisRecente?.tomador.telefone || ''}}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">Email</div>
            <div class="detail-value">{{notaMaisRecente?.tomador.email || ''}}</div>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <h3 class="section-title">
          <i class="pi pi-briefcase"></i>
          Serviço
        </h3>
        <div class="detail-grid">
          <div class="detail-item">
            <div class="detail-label">Valor Serviços</div>
            <div class="detail-value">{{notaMaisRecente?.servico.valor_servicos || ''}}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">Valor ISS</div>
            <div class="detail-value">{{notaMaisRecente?.servico.valor_iss || ''}}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">Alíquota</div>
            <div class="detail-value">{{notaMaisRecente?.servico.aliquota || ''}}</div>
          </div>
          <div class="detail-item">
            <div class="detail-label">Base Cálculo</div>
            <div class="detail-value">{{notaMaisRecente?.servico.base_calculo || ''}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <p-button 
        type="button" 
        label="Voltar" 
        severity="secondary"
        (click)="mostrarNota = false">
      </p-button>
             <p-button 
         type="button" 
         label="Download" 
         icon="pi pi-download"
         [style]="{'background': '#ffc627', 'border': '1px solid #ffc627'}"
         (click)="downloadNota(notaMaisRecente?.url)">
       </p-button>
      <p-button 
        type="button" 
        label="Emitir Nota Fiscal" 
        icon="pi pi-check"
        class="p-button-primary"
        (click)="emitirNotaFiscal()"
        [disabled]="form.get('discriminacao')?.invalid"
        >
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Confirmação de emissão"
  [modal]="true"
  [(visible)]="displayModalConfirmacaoValorAlto"
  [style]="{ width: '38rem' }"
  [breakpoints]="{ '575px': '95vw' }"
  [closable]="true">
  <div class="dialog-content-wrapper">
    <p class="declaracao-text aviso-motivo-valor-alto" style="margin-top: 0;">
      <strong>Por que este aviso aparece:</strong> o valor do serviço informado é superior a
      <strong>R$ 300.000,00</strong>. Nessa faixa de valor, é comum que a prefeitura aplique regras próprias
      (limites, trâmites e exigências adicionais) que podem afetar o fluxo da nota após a autorização.
    </p>
    <p class="declaracao-text aviso-motivo-valor-alto">
      Por isso o sistema exige que você leia as informações abaixo e confirme de forma explícita antes de emitir.
    </p>
    <div class="aviso-cancelamento-futuro" role="note">
      <p class="aviso-cancelamento-futuro__titulo">
        <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
        Cancelamento futuro da nota
      </p>
      <p>
        Quando o valor da nota ultrapassar o limite definido pelo município, o
        <strong>cancelamento pode não ser feito de forma imediata</strong> neste sistema.
        Nesses casos, será necessário abrir uma <strong>solicitação de cancelamento</strong> junto à prefeitura para
        <strong>análise do fiscal do município</strong>.
      </p>
    </div>
    <p class="declaracao-text">
      Confirme se deseja prosseguir com a emissão desta NFS-e. A operação só será concluída após você clicar em
      <strong>Confirmar e emitir</strong>.
    </p>
  </div>
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <p-button
        type="button"
        label="Voltar"
        severity="secondary"
        (click)="cancelarEmissaoComValorAlto()">
      </p-button>
      <p-button
        type="button"
        label="Confirmar e emitir"
        icon="pi pi-check"
        severity="success"
        (click)="confirmarEmissaoComValorAlto()">
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog 
  header="Declaração de Emissão Retroativa" 
  [modal]="true" 
  [(visible)]="displayModalDeclaracao"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="false"
  [closable]="false">
  <div class="dialog-content-wrapper">
    <div class="declaracao-content">
      <p class="declaracao-text">
        <strong>Declaro estar ciente de que a emissão de NFS-e em caráter retroativo poderá gerar a necessidade de recolhimento de tributos complementares, bem como a incidência de juros, multa e demais encargos legais, nos termos da legislação aplicável.</strong>
      </p>
      <p class="declaracao-text">
        <strong>Reconheço que é de minha responsabilidade informar imediatamente a equipe contábil da Advventure sobre a referida emissão, a fim de possibilitar a correta apuração e regularização fiscal.</strong>
      </p>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <p-button 
        type="button" 
        label="Cancelar" 
        severity="secondary"
        (click)="cancelarDeclaracao()">
      </p-button>
      <p-button 
        type="button" 
        label="Aceitar e Continuar" 
        icon="pi pi-check"
        severity="success"
        (click)="aceitarDeclaracao()">
      </p-button>
    </div>
  </ng-template>
</p-dialog>
